export interface Blacklist_New {
  _id: string;
  name: string;
  default: boolean;
  associatedFunnel?: string;
  createDate?: string;
  updatedAt?: string;
  blacklistType: BlacklistTypes;
  blacklistScope: BlacklistScopes;
  items: BlacklistItem[];
  action?: 'add' | 'replace' | 'remove';
}

export interface BlacklistItem {
  _id?: string;
  companyName?: string;
  companyUrn?: string;
  companyLinkedinUrl?: string;
  contactUrl?: string;
  contactLinkedinUrl?: string;
  contactVanityName?: string;
}

export interface FunnelBlacklistedCompany {
  companyName: string;
  companyUrn: string;
}

export enum BlacklistTypes {
  COMPANY = 'company',
  CONTACT = 'contact',
}

export enum BlacklistScopes {
  GLOBAL = 'global',
  LOCAL = 'local',
}